import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFInput } from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import closeIcon from "../../../assets/icons/close.svg"
import { Link } from "react-router-dom"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { postFinanceAccountGroup, postFinanceCostCategory } from "../../../services/finance/finance"
import FinanceCat from "../../../components/Common/chooseFields/financeCat"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"

const schema = yup.object().shape({
  name: yup.string().required("Account Name is Required"),
})

const Edit = ({ loading, onUpdate, id, error, close, ...props }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })
  const [isLoading, setIsLoading] = useState(false)
  // const [groupFields, setGroupFields] = useState([])
  const [revenue, setRevenue] = useState(true)
  const [nonRevenue, setNonRevenue] = useState(false)

  useEffect(() => {
    if (props?.editItem?.modal) {
      console.log(
        `props?.editItem?.value?.parent`,
        props?.editItem?.value?.parent
      )

      reset({
        ...props?.editItem?.value,
      })
      setRevenue(props?.editItem?.value?.allocate_revenue_item)
      setNonRevenue(props?.editItem?.value?.allocate_non_revenue_item)
    }
  }, [props?.editItem?.modal])

  const handleRevenueCheck = dt => {
    setRevenue(!dt)
  }

  const handleNonRevenueCheck = dt => {
    setNonRevenue(!dt)
  }

  const handleRegistration = async data => {
    console.log(`regist---`, data)

    try {
      setIsLoading(true)
      const createdSeries = await postFinanceCostCategory({
        ...data,
        name: data?.name,
        allocate_revenue_item: revenue ? 1 : 0,
        allocate_non_revenue_item: nonRevenue ? 1 : 0,
        description: "",
      })
      toastSuccess(createdSeries?.message)
      onUpdate && onUpdate(createdSeries?.data)
      close()
      reset()
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>
            {props?.editItem?.modal
              ? "Edit Cost Category"
              : "New Cost Category"}
          </h5>{" "}
          <img
            src={closeIcon}
            alt=""
            onClick={close}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <>
          <ModalBody>
            <FormProvider {...methods}>
              <Form id={`ev-form`} onSubmit={handleSubmit(handleRegistration)}>
                <Row>
                  <Col lg={12}>
                    <FormGroup className="mb-4">
                      <Label>
                        Name<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Name"
                        name={"name"}
                        invalid={!!errors.name}
                      />
                      <FormFeedback invalid>
                        {errors.name?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col
                    lg={"auto"}
                    onClick={() => handleRevenueCheck(revenue)}
                    className="mt-auto"
                  >
                    <FormGroup className="mt-2">
                      <input
                        type="checkbox"
                        className="ever-rise-checkbox"
                        name={"allocate_revenue_item"}
                        checked={revenue}
                      />
                      <Label className="ms-2">Allocate Revenue Item</Label>
                    </FormGroup>
                  </Col>
                  <Col
                    lg={"auto"}
                    onClick={() => handleNonRevenueCheck(nonRevenue)}
                    className="mt-auto"
                  >
                    <FormGroup className="mt-2">
                      <input
                        type="checkbox"
                        className="ever-rise-checkbox"
                        name={"allocate_non_revenue_item"}
                        checked={nonRevenue}
                      />
                      <Label className="ms-2">Allocate Non-Revenue Item</Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </ModalBody>
          <ModalFooter>
            <LoadingButton
              form={`ev-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {props?.editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </ModalFooter>
        </>
      )}
    </>
  )
}

const EditCostCategory = ({ buttonLabel, className, ...props }) => {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])
  useEffect(() => {
    if (props?.show) {
      setModal(true)
    }
  }, [props?.show])

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <Edit
          close={() => {
            setModal(false)
            props?.onReset()
          }}
          {...props}
        />
      </Modal>
    </>
  )
}

export default EditCostCategory
